export const defaultDayHighlightSkin = 'standard';
